import { render, staticRenderFns } from "./LogoInput.vue?vue&type=template&id=c98b5154"
import script from "./LogoInput.vue?vue&type=script&lang=js"
export * from "./LogoInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports